var map = {
	"./active_filters.svg": "85db",
	"./comission.svg": "d262",
	"./comission_desktop.svg": "0833",
	"./comission_details.svg": "472b",
	"./download.svg": "d9b3",
	"./empty.svg": "0bfb",
	"./empty_desktop.svg": "0e49",
	"./filters.svg": "6aab",
	"./filters_desktop.svg": "cb11",
	"./giftcard.svg": "7b79",
	"./giftcard_desktop.svg": "10c0",
	"./giftcard_desktop_failed.svg": "1cce",
	"./giftcard_details.svg": "8d2b",
	"./giftcard_details_failed.svg": "0497",
	"./giftcard_failed.svg": "601e",
	"./investment.svg": "d03b",
	"./investment_desktop.svg": "50d3",
	"./investment_desktop_failed.svg": "e4dc",
	"./investment_details.svg": "52da",
	"./investment_details_failed.svg": "d9c7",
	"./investment_failed.svg": "4761",
	"./mkt_desktop_failed.svg": "aab0",
	"./mkt_details_failed.svg": "a08a",
	"./mkt_failed.svg": "dcde",
	"./mkt_purchase.svg": "07bd",
	"./mkt_purchase_desktop.svg": "5c8e",
	"./mkt_purchase_details.svg": "2cb5",
	"./mkt_sale.svg": "0086",
	"./mkt_sale_desktop.svg": "6d45",
	"./mkt_sale_details.svg": "9890",
	"./payment.svg": "5da3",
	"./payment_desktop.svg": "ce80",
	"./payment_desktop_failed.svg": "742c",
	"./payment_details.svg": "03cc",
	"./payment_details_failed.svg": "c804",
	"./payment_failed.svg": "f982",
	"./refund.svg": "c4cf",
	"./refund_desktop.svg": "409b",
	"./refund_details.svg": "fc62",
	"./topup.svg": "62e4c",
	"./topup_desktop.svg": "f5ff",
	"./topup_desktop_failed.svg": "33c0",
	"./topup_details.svg": "a528",
	"./topup_details_failed.svg": "6bcd",
	"./topup_failed.svg": "1a3a",
	"./voucher.svg": "edfb",
	"./voucher_desktop.svg": "4f17",
	"./voucher_desktop_failed.svg": "690e",
	"./voucher_details.svg": "232c",
	"./voucher_details_failed.svg": "c7d6",
	"./voucher_failed.svg": "e8d8",
	"./withdraw.svg": "ec8b",
	"./withdraw_desktop.svg": "15cd",
	"./withdraw_details.svg": "89a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d08e";